// initial state
const state = {
    profile: {},
    user: {},
    company: {},
    services: {},
    locations: {},
    workplaces: {},
    departments: {},
    users: {},
    emulatedCompanyId: null,
    serviceVersion: 'unknown',
}



// getters
const getters = {
}

// actions
const actions = {
}

// mutations
const mutations = {
  setProfile(state, profile) {
    state.profile = profile;
  },
  setUser(state, user) {
    state.user = user;
  },
  setCompany(state, company) {
    state.company = company;
  },
  setWorkplaces(state, workplaces) {
    state.workplaces = workplaces;
  },
  setDepartments(state, departments) {
    state.departments = departments;
  },
  setUsers(state, users) {
    state.users = users;
  },
  setEmulatedCompanyId(state, emulatedCompanyId) {
    state.emulatedCompanyId = emulatedCompanyId;
  },
  setServiceVersion(state, serviceVersion) {
    state.serviceVersion = serviceVersion;
  },
  setServices(state, services) {
    state.services = services;
  },
  setRooms(state, rooms) {
    state.rooms = rooms;
  },
  setLocations(state, locations) {
    state.locations = locations;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}